"use client";
import clsx from "clsx";
import { Mail } from "lucide-react";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { useState } from "react";
import { APP_LANGUAGES, APP_STRINGS_LABELS, getAppStringForLanguage } from "utils/language";

const PhoneIcon = ({ hasMobileBg, hasDesktopBg }: { hasMobileBg?: boolean; hasDesktopBg?: boolean }) => (
  <svg
    className={clsx(
      hasMobileBg ? "text-accent-700" : "bg-[#91c79e] text-white",
      hasDesktopBg ? "md:text-accent-700" : "bg-[#91c79e] md:text-white"
    )}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.025 10.7167L11.9084 10.475C11.4 10.4167 10.9 10.5917 10.5417 10.95L9.00837 12.4834C6.65003 11.2834 4.7167 9.35836 3.5167 6.9917L5.05837 5.45003C5.4167 5.09169 5.5917 4.5917 5.53337 4.08336L5.2917 1.98336C5.1917 1.1417 4.48337 0.508362 3.63337 0.508362H2.1917C1.25003 0.508362 0.466701 1.2917 0.525034 2.23336C0.966701 9.35003 6.65837 15.0334 13.7667 15.475C14.7084 15.5334 15.4917 14.75 15.4917 13.8084V12.3667C15.5 11.525 14.8667 10.8167 14.025 10.7167Z"
      fill="currentColor"
    />
  </svg>
);

const PhoneBtn = ({ hasMobileBg = false, hasDesktopBg = false, language = APP_LANGUAGES.ENGLISH }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="lg:relative">
      <Popover>
        <PopoverButton>
          <button
            onClick={() => setOpen(!open)}
            className="mr-2 inline-flex cursor-pointer items-center self-center align-middle text-[14px] font-medium text-primary-700 hover:no-underline"
          >
            <span className="rounded-full border-white/20 bg-[#91c79e] p-1 text-white ">
              <PhoneIcon hasMobileBg={hasMobileBg} hasDesktopBg={hasDesktopBg} />
            </span>
            <span className={clsx("ml-2 hidden text-primary-700 lg:block", open && "underline")}>
              {`${getAppStringForLanguage(APP_STRINGS_LABELS.QUESTIONS_CALL_TEXT, language)} ${getAppStringForLanguage(APP_STRINGS_LABELS.SOLDAVE_NUMBER, language)}`}
            </span>
          </button>
        </PopoverButton>
        <PopoverPanel className="text-accent-800 mt-5 w-[100vw] origin-top-right divide-y border border-neutral-200 bg-white shadow-xl focus:outline-none md:w-full lg:mt-2 lg:w-[25rem]">
          <div className="border-b border-neutral-200 py-9">
            <span className="text-2xl font-medium">
              {getAppStringForLanguage(APP_STRINGS_LABELS.TEXT_US, language)}
            </span>
            <p className="mt-2 text-sm font-light">
              {getAppStringForLanguage(APP_STRINGS_LABELS.QUESTIONS_ANSWERED_FAST, language)}
            </p>
            <div className="mt-5 flex items-center gap-x-2 text-sm">
              <Mail strokeWidth={1} />
              <a
                href={`sms:${getAppStringForLanguage(APP_STRINGS_LABELS.SOLDAVE_NUMBER_E164, language)}`}
                className="text-accent-700 underline"
              >
                {getAppStringForLanguage(APP_STRINGS_LABELS.SOLDAVE_NUMBER, language)}
              </a>
            </div>
          </div>
          <div className="py-9">
            <span className="text-2xl font-medium">
              {getAppStringForLanguage(APP_STRINGS_LABELS.CALL_US, language)}
            </span>
            <p className="mt-2 text-sm font-light">
              {getAppStringForLanguage(APP_STRINGS_LABELS.JUMP_ON_THE_PHONE, language)}
            </p>
            <div className="mt-5 flex items-center gap-x-2 text-sm">
              <PhoneIcon hasMobileBg hasDesktopBg />
              <a
                href={`tel:${getAppStringForLanguage(APP_STRINGS_LABELS.SOLDAVE_NUMBER_E164, language)}`}
                className="text-accent-700 underline"
              >
                {getAppStringForLanguage(APP_STRINGS_LABELS.SOLDAVE_NUMBER, language)}
              </a>
            </div>
          </div>
        </PopoverPanel>
      </Popover>
    </div>
  );
};

export { PhoneBtn };
